import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';

// Drapeaux SVG
const FranceFlag = () => (
  <svg className="w-5 h-5 rounded-sm" viewBox="0 0 640 480">
    <rect width="213.3" height="480" fill="#002654"/>
    <rect x="213.3" width="213.4" height="480" fill="#fff"/>
    <rect x="426.7" width="213.3" height="480" fill="#ce1126"/>
  </svg>
);

const UKFlag = () => (
  <svg className="w-5 h-5 rounded-sm" viewBox="0 0 640 480">
    <path fill="#012169" d="M0 0h640v480H0z"/>
    <path fill="#FFF" d="m75 0 244 181L562 0h78v62L400 241l240 178v61h-80L320 301 81 480H0v-60l239-178L0 64V0h75z"/>
    <path fill="#C8102E" d="m424 281 216 159v40L369 281h55zm-184 20 6 35L54 480H0l240-179zM640 0v3L391 191l2-44L590 0h50zM0 0l239 176h-60L0 42V0z"/>
    <path fill="#FFF" d="M241 0v480h160V0H241zM0 160v160h640V160H0z"/>
    <path fill="#C8102E" d="M0 193v96h640v-96H0zM273 0v480h96V0h-96z"/>
  </svg>
);

const LanguageSelector = ({ className = '' }) => {
  const { language, toggleLanguage, t } = useLanguage();

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={toggleLanguage}
      className={`flex items-center gap-2 font-medium text-sm px-3 py-2 hover:bg-primary/10 ${className}`}
      title={language === 'fr' ? 'Switch to English' : 'Passer en français'}
    >
      {language === 'fr' ? <UKFlag /> : <FranceFlag />}
      <span className="text-foreground/80 hover:text-foreground">
        {language === 'fr' ? 'EN' : 'FR'}
      </span>
    </Button>
  );
};

export default LanguageSelector;
